import React from 'react';
import './OrbitalLoader.css';
import logo from '../pages/Logo/CompanyLogo.png';

const OrbitalLoader = ({ message = 'Loading...' }) => {
    return (
        <div className="simple-loader-overlay">
            <div className="simple-loader-box">
                <img src={logo} alt="logo" className="simple-loader-logo" />
                <div className="simple-spinner"></div>
                <p className="simple-loader-text">{message}</p>
            </div>
        </div>
    );
};

export default OrbitalLoader;
